// Block 224c-pre: the canonical currency symbol map for the FRONTEND.
//
// Mirror of "Aidey Backend/lib/currency.js". They MUST stay in step. Two files rather
// than one is the floor imposed by the two build roots — a Create React App build
// refuses to import modules from outside scheduler/src — not a choice.
//
// There were eight copies of this map and they disagreed, so the same currency
// rendered differently depending on the screen: CAD was 'CA$' on invoices and
// purchase orders but 'C$' on all three proposal screens; AED and CHF split between
// backend and frontend. This map is the fourteen-currency superset already used by
// invoices and purchase orders.

// ONE CONVENTION, matching Aidey Backend/lib/currency.js: a symbol made of LETTERS carries a
// trailing space, a GLYPH does not. This map and the backend's were byte-identical and both had
// CHF without a space while AED — the same shape — had one. Two copies agreeing with each other
// says nothing about either being right; ci/currency_cases.json now holds the truth and BOTH
// suites assert against it.
export const CURRENCY_SYMBOLS = {
  GBP: '£', USD: '$', EUR: '€', CAD: 'CA$', AUD: 'A$', CHF: 'CHF ', JPY: '¥',
  SEK: 'kr ', NOK: 'kr ', DKK: 'kr ', NZD: 'NZ$', SGD: 'S$', AED: 'AED ', ZAR: 'R',
};

/** Symbol for a currency code, falling back to the code itself. */
export function currencySymbol(code) {
  return CURRENCY_SYMBOLS[code] || code || '';
}

/** "£1,200.00" — symbol, thousands separators, two decimals. The client-facing form. */
export function formatMoney(amount, code) {
  const n = Number(amount || 0);
  // THE SIGN GOES OUTSIDE THE SYMBOL — "-£45.50", not "£-45.50". Mirrors the backend; the shared
  // cases in Aidey Backend/ci/currency_cases.json are what keep the two the same.
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  return `${sign}${currencySymbol(code)}${abs.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
